import { render, staticRenderFns } from "./CriticalSupplyDiagnosticModal.vue?vue&type=template&id=252b744e&scoped=true"
import script from "./CriticalSupplyDiagnosticModal.vue?vue&type=script&lang=js"
export * from "./CriticalSupplyDiagnosticModal.vue?vue&type=script&lang=js"
import style0 from "./CriticalSupplyDiagnosticModal.vue?vue&type=style&index=0&id=252b744e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b744e",
  null
  
)

export default component.exports